import React            from "react"
import PropTypes        from "prop-types"
import Grid             from "./Grid"
import Date             from "./Date"
import { getPath, getCodeOrConcept } from "../../pages/ClaimAnalysisPage/ClaimViewPage/PatientDetails"
import moment           from "moment"
import SelectionCheckbox from "./SelectionCheckbox.jsx"
import { gridStyles } from "../../pages/ClaimAnalysisPage/ClaimViewPage/PatientDetails/PatientDetails";

export default class ConditionList extends React.Component
{
    static propTypes = {
        resources: PropTypes.array,
        onSelectionChange: PropTypes.func,        
    };

    

    render()
    {
        let recs   = this.props.resources || []
        let length = recs.length;
       
        return (
            <div style={gridStyles.wrapper}>
              <div style={gridStyles.body}>
                <div style={gridStyles.content}>

            <Grid
                rows={(recs || []).map(o => o.resource)}
                title={`${length} Condition${length === 1 ? "" : "s"}`}
                comparator={(a,b) => {
                    let dA = getPath(a, "onsetDateTime");
                    let dB = getPath(b, "onsetDateTime");
                    dA = dA ? +moment(dA) : 0;
                    dB = dB ? +moment(dB) : 0;
                    return dB - dA;
                }}
                cols={[
                    
                    {
                        label: <div className="text-center">Select</div>,
                        render: o => (
                            <div className="text-center">
                                <SelectionCheckbox
                                    row={o}
                                    checked={o.isSelected}
                                    onSelectionChange={this.props.onSelectionChange}                                    
                                />
                            </div>
                        )
                    },
                    {
                        label: "Condition",
                        render: o => {
                            let name   = "-";
                            let code   = "-";

                            if (o.code) {
                                if (o.code.text) {
                                    name = o.code.text;
                                }
                                if (Array.isArray(o.code.coding) && o.code.coding.length) {
                                    let c = o.code.coding[0]

                                    if (c.display) {
                                        name = c.display
                                    }
                                    if (c.code) {
                                        code = c.code
                                    }
                                }
                            }
                            return (
                                <div>
                                    <b>{ name }</b>
                                    <small className="text-muted pull-right">
                                        { code }
                                    </small>
                                </div>
                            )
                        }
                    },
                    {
                        label: <div className="text-center">Clinical Status</div>,
                        render: o => <div className="text-center">{ getCodeOrConcept(o.clinicalStatus) }</div>
                    },
                    {
                        label : <div className="text-center">Verification Status</div>,
                        render: o => <div className="text-center">{ getCodeOrConcept(o.verificationStatus) }</div>
                    },
                    {
                        label: <div className="text-center">Onset Date</div>,
                        render : o => {
                            let onset = o.onsetDateTime || "";
                            return (
                                <div className="text-center">
                                    {
                                        onset ?
                                        <Date moment={o.onsetDateTime}/> :
                                        "-"
                                    }
                                </div>
                            );
                        }
                    }
                ]}
            />
        </div>
        </div>
        </div>

        );
    }
}